import axios from 'axios';

export const BASE_URL = 'https://immersive-game-india.confirmu.com';

export let headers = {
  'Tenant-Access-Token': 'MzNkODdiYzkwMTQxNGFjMmYwNTQ1MGM4ZjU3YTU1YWM=',
  'Tenant-Access-Key': 'iyOCG7J90C3oDg',
};

export const api = axios.create({
  baseURL: BASE_URL,
  headers
});

